import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComingSoonPageComponent } from './composants/coming-soon-page/coming-soon-page.component';
import { AddPotifRecComponent } from './composants/add-potif-rec/add-potif-rec.component';
import { DocumentAdminComponent } from './composants/document-admin/document-admin.component';
import { ViewDocumentComponent } from './composants/view-document/view-document.component';
import { SettingsComponent } from './composants/settings/settings.component';
import { CoreRoutingModule } from './core-routing.module';
import { SharedModule } from '../shared/shared.module';
@NgModule({
    declarations: [
ComingSoonPageComponent,
AddPotifRecComponent,
DocumentAdminComponent,
ViewDocumentComponent,
SettingsComponent,
      ],
      imports: [
        CommonModule, 
        CoreRoutingModule,
        SharedModule
      ],
      exports: [
        CommonModule // Export CommonModule to make *ngIf, *ngFor, etc. available
      ],
})
export class CoreModule  { }

